import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header } from './Header';
import { Navigation } from './Navigation';
import { BottomNav } from './BottomNav';
import { useIsMobile } from '../hooks/useIsMobile';
export const Layout = ({ children, hideNav = false }) => {
    const isMobile = useIsMobile();
    return (_jsxs("div", { style: styles.container, children: [_jsx(Header, {}), _jsxs("div", { style: styles.content, children: [!hideNav && !isMobile && _jsx(Navigation, {}), _jsx("main", { style: {
                            ...styles.main,
                            paddingBottom: isMobile ? '72px' : styles.main.padding,
                        }, children: children })] }), !hideNav && _jsx(BottomNav, {})] }));
};
const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f5f7 0%, #ffffff 50%, #f9f9fb 100%)',
    },
    content: {
        display: 'flex',
    },
    main: {
        flex: 1,
        padding: '40px',
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
    },
};
//# sourceMappingURL=Layout.js.map